import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
import kLineChart from '@/components/bigDataChart/kLineChart';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterKLineChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '590px'
    },
    monitorType: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    initNum: {
      type: Number,
      default: 0
    }
  },
  components: {
    kLineChart: kLineChart
  },
  data: function data() {
    return {
      targetType: '',
      targetList: [],
      url: '',
      dataObj: {},
      dataObjSource: {},
      targetListSource: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteType') {
        _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/chart';
      }
    });
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.$refs.chart2) return;

      if (!this.startTime || !this.endTime) {
        this.$message.error('请选择时间');
        return;
      }

      var that = this;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        scopeId: window.sessionStorage.getItem('siteId') || '',
        type: '2',
        column: 'data_time',
        order: 'asc',
        dataType: '11'
      };
      var options = [];
      getAction(this.url, params).then(function (res) {
        if (res.success) {
          that.targetList = res.result.query.factors;
          that.targetType = that.targetList[0].code;
          that.dataObj = {};
          res.result.query.factors.forEach(function (v, i) {
            options.push({
              label: v.alias || v.title,
              value: v.code,
              categoryName: v.categoryName
            });
          });

          if (res.result.records.length > 0) {
            var _loop = function _loop(key) {
              that.dataObj[key] = [];
              res.result.records.forEach(function (item) {
                that.dataObj[key].push([item.dataTime, item.factor[key].first, item.factor[key].last, item.factor[key].min, item.factor[key].max]);
              });
            };

            for (var key in res.result.records[0].factor) {
              _loop(key);
            }

            console.log(that.dataObj, 97);
          }

          if (state) {
            _this2.$nextTick(function () {
              that.$parent.$parent.$refs.colControl.firstState = true;
              that.$emit('factorOption', options);
            });
          }

          _this2.dataObjSource = JSON.parse(JSON.stringify(that.dataObj));
          _this2.targetListSource = JSON.parse(JSON.stringify(that.targetList)); // that.$refs.chart2.initKLineChart(that.dataObj[that.targetType] || {})
        }
      });
    },
    targetTypeChange: function targetTypeChange(e) {
      this.targetType = e.target.value;
      console.log('e', e);
      console.log('e', this.dataObj);
      console.log('e', this.dataObj[this.targetType]);
      this.$refs.chart2.initKLineChart(JSON.parse(JSON.stringify(this.dataObj[this.targetType] || {})));
    },
    changeChartInit: function changeChartInit() {
      this.$refs.chart2.initKLineChart(JSON.parse(JSON.stringify(this.dataObj[this.targetType] || {})));
    }
  },
  watch: {
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.querySewageQuotaList();
      }
    },
    initNum: function initNum() {
      this.querySewageQuotaList(false);
    }
  }
};